/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    code: "code",
    h3: "h3",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The Drawer component is a ", _jsx(_components.a, {
        href: "/uilib/components/modal",
        children: "Modal"
      }), " variation that appears as a side panel at any chosen side of the page; top, bottom, left or right (default ", _jsx(_components.code, {
        children: "right"
      }), "). A Drawer is typically used to show additional information. It can also be used to have easy/quick tasks while being in context."]
    }), "\n", _jsx(_components.h3, {
      children: "Parts in Drawer"
    }), "\n", _jsx(_components.p, {
      children: "To provide custom content to parts of the Drawer, a set of component parts are provided:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "<Drawer.Navigation>"
        }), ": The navigation field at the top of the component, default with a close button (Equal to the prop ", _jsx(_components.code, {
          children: "navContent"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "<Drawer.Header>"
        }), ": The header field of the component, where the ", _jsx(_components.code, {
          children: "title"
        }), " will appear (Equal to the prop ", _jsx(_components.code, {
          children: "headerContent"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "<Drawer.Body>"
        }), ": The body of the Drawer, provided with a section background color, default ", _jsx(_components.code, {
          children: "black-3"
        }), " (Equal to the prop ", _jsx(_components.code, {
          children: "modalContent"
        }), ")."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "More detailed information"
    }), "\n", _jsxs(_components.p, {
      children: ["For more details regarding the component functionality, check out the ", _jsx(_components.a, {
        href: "/uilib/components/modal",
        children: "Modal documentation"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
